import { PagePaths } from '@/routes/page-paths';

export const SETTINGS_TAB_PARAM = 'tab';

export const settingsTabKeys = {
  account: 'account',
  myProfile: 'my-profile',
  entityAffiliations: 'entity-affiliations',
  notifications: 'notifications',
  wallet: 'wallet',
  notes: 'notes',
} as const;

export const walletSettingsPath = `${PagePaths.settings}?${SETTINGS_TAB_PARAM}=${settingsTabKeys.wallet}`;
